import { createApi } from '@reduxjs/toolkit/query/react'
import type { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query'

import { baseQuery } from 'common/store/api/fetchBaseQuery'
import { REDUCERS } from 'common/store/reducerConstants'

import type { IFaqQuestion } from 'features/Faq/interfaces/IFaq'

export const faqApi = createApi({
  reducerPath: REDUCERS.FAQ,
  baseQuery: baseQuery(),
  endpoints: (build: EndpointBuilder<BaseQueryFn, string, string>) => ({
    fetchQuestions: build.query({
      query: () => ({
        url: '/faqs',
      }),
      transformResponse: ({ items }: { items: IFaqQuestion[] }) =>
        items.sort((a: IFaqQuestion, b: IFaqQuestion) => a.order - b.order),
    }),
  }),
})

export const { useFetchQuestionsQuery }: any = faqApi
